export const sportsContent = {
    es: {
        eyebrow: 'DEPORTE EN DIRECTO',
        title: 'Descubre todos los canales deportivos y tus competiciones favoritas en una sola suscripción.',
        leagueOrder: ['La Liga', 'Copa del Rey', 'UEFA Champions League', 'Premier League', 'Serie A', 'Bundesliga', 'Ligue 1', 'UEFA Europa League', 'Ligue 2', 'Jupiler Pro League', 'Saudi League', 'F1', 'UFC'],
    },
};
